<template>
  <div class="flex-center">
    <v-btn color="admin" dark outlined @click="onExport">
      <v-icon left>mdi-file-excel-outline</v-icon>Xuất Excel
    </v-btn>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import * as XLSX from 'xlsx'
import {saveAs} from 'file-saver'
import {get} from 'lodash'
export default {
  computed: {
    ...mapGetters('auth', ['user']),
  },
  methods: {
    ...mapActions({fetchCVsIndependent: 'cv/fetchCVsIndependent'}),
    async onExport() {
      this.$loading.active = true
      const cvs = await this.fetchCVsIndependent({
        adminQueryType: 'g6ExamPrep',
        fromAdmin: true,
        _start: 0,
        _limit: -1,
      })
      const isUserAdminBoth = this.$helpers.ALLOWED_VIEW_DETAIL_TRANS_SCHOLARSHIP.includes(this.user.id)
      const worksheet = XLSX.utils.json_to_sheet(
        cvs.map(cv => {
          const res = {
            'Mã hồ sơ': cv.code,
            'Cơ sở': cv.department,
            'Họ tên học sinh': cv.name,
            'Số điện thoại đăng ký': cv.parentUsername,
            'Email': cv.parentEmail,
            'Đăng ký lúc': moment(get(cv, 'g6ExamPrepTransactions.0.transactionTime')).format(
              'DD/MM/YYYY HH:mm'
            ),
          }
          if (isUserAdminBoth) {
            const {transAccount, transBank, transId} = this.renderTransDetail(cv)
            res['Mã tài khoản nhận tiền'] = transAccount
            res['Mã tham chiếu giao dịch'] = transId
            res['Ngân hàng nhận tiền'] = transBank
          }
          return res
        })
      )
      const workbook = {Sheets: {data: worksheet}, SheetNames: ['data']}
      const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'})
      const data = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      })
      saveAs(data, 'ho-so-k6-lop-hdpplb.xlsx')
      this.$loading.active = false
    },
    renderTransDetail(cv) {
      const code = get(cv, 'g6ExamPrepTransactions.0.code', '')
      const transId = get(cv, 'g6ExamPrepTransactions.0.transactionId', '')

      let transAccount = `9LTV${code}`
      let transBank = `Vietinbank`

      return {transAccount, transBank, transId}
    },
  },
}
</script>
